import React from 'react';
import { SectionsLessonsTab } from '@/features/course-management';
import { trainerCourseSectionsService } from '@/features/course-management/services/trainerService';
import type { SectionWithLessons } from '@/features/course-management';

interface TrainerSectionsLessonsTabProps {
  courseId?: number;
  onUpdate?: (sections: SectionWithLessons[]) => void;
}

const TrainerSectionsLessonsTab: React.FC<TrainerSectionsLessonsTabProps> = ({ courseId, onUpdate }) => (
  <SectionsLessonsTab
    courseId={courseId}
    onUpdate={onUpdate}
    service={trainerCourseSectionsService}
  />
);

export default TrainerSectionsLessonsTab;
